import React, { Fragment, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Drawer from 'rc-drawer';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import { Button } from 'reactstrap';
import ProductDetail from 'components/Agile/product/productDetail';
import ProductTable from 'components/Agile/product/productTable';
import ProductAdd from 'components/Agile/product/productMaintenance/productAdd';
import IntlMessages from 'util/IntlMessages';
import CircularProgress from 'components/CircularProgress';
import CustomScrollbars from 'util/CustomScrollbars';
import {
    fetchProducts,
    handleProductRequestClose,
    showProductLoader,
    onAddProduct,
    onToggleProductDrawer,
    fetchProductLookupData,
} from 'actions/product';

const Component = () => {
    const dispatch = useDispatch();

    const width = useSelector(state => state.settings.width);
    const loader = useSelector(state => state.products.loader);
    const alertMessage = useSelector(state => state.products.alertMessage);
    const showMessage = useSelector(state => state.products.showMessage);
    const noContentFoundMessage = useSelector(state => state.products.noContentFoundMessage);
    const drawerState = useSelector(state => state.products.drawerState);
    const product = useSelector(state => state.products.product);
    const productList = useSelector(state => state.products.productList);

    useEffect(() => {
        dispatch(showProductLoader());
        dispatch(fetchProducts());
        dispatch(fetchProductLookupData());
    }, []);

    const productSideBar = () => {
        return <div className="module-side">
            <div className="module-side-header">
                <div className="module-logo">
                    <i className="zmdi zmdi-city-alt mr-4" />
                    <span><IntlMessages id="sidebar.products" /></span>
                </div>
            </div>

            <div className="module-side-content">
                <CustomScrollbars className="module-side-scroll scrollbar"
                    style={{ height: width >= 1200 ? 'calc(100vh - 200px)' : 'calc(100vh - 80px)' }}>
                    <div className="module-add-task">
                        <Button className="btn-block jr-btn" color="primary"
                            onClick={() => dispatch(onAddProduct())}>
                            <i className="zmdi zmdi-accounts-add zmdi-hc-fw" />
                            <span><IntlMessages id="product.addProduct" /></span>
                        </Button>
                    </div>
                </CustomScrollbars>
            </div>
        </div>;
    };

    const productRequestClose = () => {
        dispatch(handleProductRequestClose());
    };

    return (
        <div className="app-wrapper">
            <div className="app-module animated slideInUpTiny animation-duration-3">
                <div className="d-block d-xl-none">
                    <Drawer
                        touch={true}
                        transitions={true}
                        enableDragHandle={true}
                        open={drawerState}
                        onOpenChange={() => dispatch(onToggleProductDrawer())}
                        sidebar={productSideBar(product)} />
                </div>
                <div className="app-module-sidenav d-none d-xl-flex">
                    {productSideBar(product)}
                </div>
                <div className="module-box">
                    <div className="module-box-content">
                        <div className="module-box-header">
                            <span className="icon-btn drawer-btn d-flex d-xl-none"
                                onClick={() => dispatch(onToggleProductDrawer())}>
                                <i className="zmdi zmdi-menu" />
                            </span>
                        </div>
                        <CustomScrollbars className="module-list-scroll scrollbar"
                            style={{ height: width >= 1200 ? 'calc(108vh - 265px)' : 'calc(108vh - 245px)' }}>
                            {loader ?
                                <div
                                    className="loader-view-block h-100">
                                    <div className="loader-view">
                                        <CircularProgress />
                                    </div>
                                </div>
                                :
                                productList && productList.length > 0 ?
                                    <Fragment>
                                        <div className="app-main-content">
                                            <ProductTable />
                                            <div style={{ marginTop: 10 }}>
                                                <ProductDetail />
                                            </div>
                                        </div>
                                    </Fragment>
                                    :
                                    <div className="h-100 d-flex align-items-center justify-content-center">
                                        {noContentFoundMessage}
                                    </div>
                            }
                        </CustomScrollbars>

                    </div>
                </div>
            </div>
            <ProductAdd />

            {showMessage && NotificationManager.success(alertMessage, productRequestClose())}
            <NotificationContainer />

        </div>
    );
};

export default Component;



// WEBPACK FOOTER //
// ./components/Agile/product/component.js